import hostURL from './constants';
import  secureLocalStorage  from  "react-secure-storage";
const authToken =  secureLocalStorage.getItem('token');


// to clear the localStorage after 1 hour
var hours = 1; 
var now = new Date().getTime();

// var setupTime = localStorage.getItem("msutiptrue");
var setupTime = secureLocalStorage.getItem("msutiptrue");
if (setupTime == null) {
  secureLocalStorage.setItem("msutiptrue", now);
} else {
  if (now - setupTime > hours * 60 * 60 * 1000) {
    secureLocalStorage.clear();
    sessionStorage.clear();
    console.clear();
    secureLocalStorage.setItem("msutiptrue", now);
  }
}
// to clear the localStorage after 1 hour

let myCommonApiCall=[];
myCommonApiCall.storeSearchData = async (values, sroute)=>{

    const formData = { 
      userId: secureLocalStorage.getItem('userRef'),
      route: window.location.href,
      subRoute: sroute,
      formData:JSON.stringify(values)
    };

    // setLoading(true);
   await fetch(hostURL+"api/usersearchdata", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization:  authToken,
      },
      body: JSON.stringify(formData)
    })
      .then((response) => response.json())
      .then((json) => {
        // setLoading(false);
      })
      .catch((error) => console.error(error));
  };

  myCommonApiCall.signOut= async()=>{
    await fetch(hostURL+"api/users/signOut", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    })
      .then((response) => {
        return new Promise((resolve) =>
          response.json().then((json) => {
            resolve({
              status: response.status,
              ok: response.ok,
              json
            });
          })
        );
      })
      .then(({ status, json, ok }) => {
        const message = json.message;
        if (status == 200) {
          document.cookie =
            "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            secureLocalStorage.removeItem("token");
            secureLocalStorage.removeItem("userRef");
          window.location.assign("/UserLogin");
        }
      });
  }

  export default myCommonApiCall;